import { render, staticRenderFns } from "./ForumPost.vue?vue&type=template&id=5d90461e&"
import script from "./ForumPost.vue?vue&type=script&lang=js&"
export * from "./ForumPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports